import { render, staticRenderFns } from "./TeamRanking.vue?vue&type=template&id=dc4b2570&scoped=true"
import script from "./TeamRanking.vue?vue&type=script&lang=js"
export * from "./TeamRanking.vue?vue&type=script&lang=js"
import style0 from "./TeamRanking.vue?vue&type=style&index=0&id=dc4b2570&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc4b2570",
  null
  
)

export default component.exports